import script from "./RecommendCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendCard.vue?vue&type=script&setup=true&lang=js"

import "./RecommendCard.vue?vue&type=style&index=0&id=d217fa8a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d217fa8a"]])

export default __exports__